import React from "react";
import { ChatWindow } from "../types";
import PreviewDeviceFrame from "./PreviewDeviceFrame";

interface Props {
  chatWindow: ChatWindow;
}

export default function ContentWidgetPreview({ chatWindow }: Props) {
  const lc = chatWindow.languageConfig || {};
  const sc = chatWindow.styleConfig || {};

  const actionColor = sc.actionColor || "#3B82F6";
  const imageUrl = sc.contentWidgetImageUrl;
  const title = lc.contentWidgetTitle || "Your Title Here";
  const body = lc.contentWidgetBody || "Add a short description to your content widget.";
  const buttonText = lc.contentWidgetButtonText || "Learn More";
  const enabled = lc.contentWidgetEnabled ?? false;

  const launcherPosition: "Left" | "Right" =
    sc.launcherPosition === "Left" ? "Left" : "Right";
  const actualWidth = sc.windowWidth || 370;
  const actualHeight = sc.windowHeight && sc.windowHeight > 0 ? sc.windowHeight : 560;

  return (
    <div className="w-full">
      <PreviewDeviceFrame
        launcherPosition={launcherPosition}
        actualWidth={actualWidth}
        actualHeight={actualHeight}
      >
        <div
          className="relative bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden"
          style={{ width: actualWidth, height: actualHeight }}
        >
          {/* Chat header */}
          <div
            className="w-full px-4 py-3 flex items-center space-x-2"
            style={{ backgroundColor: actionColor }}
          >
            <div className="w-7 h-7 rounded-full bg-white/30 flex-shrink-0" />
            <div className="flex flex-col">
              <div className="text-white text-xs font-semibold leading-tight">Support</div>
              <div className="text-white/70 text-[10px]">Online</div>
            </div>
          </div>

          {/* Body */}
          <div className="bg-white h-full px-3 py-3 flex flex-col space-y-2 overflow-hidden">
            <div className="rounded-xl border border-slate-200 overflow-hidden shadow-sm bg-white">
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="Content widget"
                  className="w-full object-cover"
                  style={{ maxHeight: 110 }}
                />
              ) : (
                <div
                  className="w-full flex items-center justify-center bg-slate-100 text-slate-400 text-xs"
                  style={{ height: 80 }}
                >
                  No image uploaded
                </div>
              )}
              <div className="px-3 py-2">
                <div className="text-xs font-semibold text-slate-800 leading-snug mb-1 truncate">
                  {title}
                </div>
                <div className="text-[10px] text-slate-500 leading-snug line-clamp-2 mb-2">
                  {body}
                </div>
                <button
                  className="w-full text-white text-[10px] font-semibold py-1.5 rounded-lg"
                  style={{ backgroundColor: actionColor }}
                >
                  {buttonText}
                </button>
              </div>
            </div>
            <div className="rounded-xl border border-slate-200 px-3 py-2 bg-white">
              <div className="h-2 bg-slate-100 rounded w-3/4 mb-1" />
              <div className="h-2 bg-slate-100 rounded w-1/2" />
            </div>
          </div>
        </div>
      </PreviewDeviceFrame>
      {!enabled && (
        <div className="text-center text-xs text-amber-600 font-medium mt-2">
          Widget is disabled — toggle Enable to show it in the chat window.
        </div>
      )}
    </div>
  );
}
